import { HttpClient } from "../HttpClient";

export const GetTransactions = async (params = {}) => {
  try {
    
    
    const {
      userId,
      sortColumn = "dateUpdated",
      sortOrder = "desc",
      pageNumber = 1,
      rowsPerPage = 10,
      isImpersonation
    } = params;
    
    const { data } = await HttpClient.get(
      "api/subscriptions/currentUser/transactions", 
      {
        params: {
          pageNumber,
          rowsPerPage,
          sortOrder,
          ...(sortColumn && { sortColumn }),
          ...(userId && { userId }),
          ...(isImpersonation && { isImpersonation }),
        },
      }
    );
    

    return data;
  } catch (err) {
    console.error("❌ GetTransactions error:", err);
    return Promise.reject(err);
  }
};

// export const GetTransactions = async ({
//   userId,
//   sortColumn = "dateUpdated",
//   sortOrder = "desc",
//   pageNumber = 1,
//   rowsPerPage = 10,
// }) => {
//   try {
//     const { data } = await HttpClient.get("api/subscriptions/currentUser/transactions", {
//       params: {
//         pageNumber,
//         rowsPerPage,
//         sortOrder,
//         ...(sortColumn && { sortColumn }),
//         ...(userId && { userId }),
//       },
//     });
//     return data;
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
